import React, { useEffect, useState, useContext } from "react";
import { useSelector } from 'react-redux';
import ApiService from '../../functions/apiService';
import { Box, Chip, Table, TableBody, TableCell, InputAdornment, TableContainer, IconButton, TableHead, TableRow, Autocomplete, Typography, TextField, CircularProgress, Tabs, Tab, Tooltip } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Paper from '@mui/material/Paper';
import { Button, Col, Row } from "react-bootstrap";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from "moment";
import { toast } from "react-toastify";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import SearchIcon from "@mui/icons-material/Search";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';

export default function VolunteerSignup(props) {
	const { user, permission, v3Data } = useContext(AuthContext);
	const { isNightShift, mode2, onExpandChange, open, date, shift, allowedVars } = props
	const [empList, setEmpList] = useState([])
	const [posList, setPosList] = useState([])
	const [assignModal, setAssignModal] = useState(false);
	const [posId, setPosId] = useState('')
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);
	const [search, setSearch] = useState('')
	const [deleteModal, setDeleteModal] = useState(false)
	const [isFirstTime, setIsFirsttime] = useState(true);
	const [shiftCode, setShiftCode] = useState('')
	const [posCode, setPosCode] = useState('')
	const [unassignEmp, setUnassignEmp] = useState('')
	const [customModal, setCustomModal] = useState(false)
	const [key, setKey] = useState(1)
	const [key2, setKey2] = useState(1)
	const [startTime, setStartTime] = useState('')
	const [endTime, setEndTime] = useState('')
	const [assignEmp, setAssignEmp] = useState('')
	// const [shift, setShift] = useState()
	const [posList2, setPosList2] = useState([]);
	const [modalShiftName, setModalShiftName] = useState();
	const [loading, setLoading] = useState(false);
	const [unassignPosition, setUnassignPosition] = useState('');
	const [confirmModal, setConfirmModal] = useState(false);
	const [currentRow, setCurrentRow] = useState(null);
	const [actionType, setActionType] = useState("");
	const [assignModalUser, setAssignModalUser] = useState(false);
	const [customModalUser, setCustomModalUser] = useState(false);
	const [deleteModalUser, setDeleteModalUser] = useState(false)
	const [posUserDate, setPosUserDate] = useState('')
	const [posUserShiftCode, setPosUserShiftCode] = useState('')
	const [posUserStartTime, setPosUserStartTime] = useState('')
	const [posUserEndTime, setPosUserEndTime] = useState('')
	const [unAssignReason, setUnAssignReason] = useState('')
	const [requestShiftUser, setRequestShiftUser] = useState(false);
	const [revertShiftReq, setRevertShiftReq] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [editEmp, setEditEmp] = useState(null);
	const [editStartTime, setEditStartTime] = useState(null);
	const [editEndTime, setEditEndTime] = useState(null);
	const [empLoading , setEmpLoading] = useState(false);
	const [defaultCustomStart, setDefaultCustomStart] = useState('');
	const [defaultCustomEnd, setDefaultCustomEnd] = useState('');
	const [isPartialSlot, setIsPartialSlot] = useState(false);

	// Shift swap
	const EmployeeToSwap = useSelector((state) => state.dashboardReducer.EmployeeToSwap) || [];
	const [swapModal, setSwapModal] = useState(false);
	const [swapEmp, setSwapEmp] = useState(null);
	const [swapPosition, setSwapPosition] = useState(null);
	const [swapTab, setSwapTab] = useState('normal');
	const [selectedSwapEmp, setSelectedSwapEmp] = useState(null);
	const [collateralList, setCollateralList] = useState([]);
	const [swapLoading, setSwapLoading] = useState(false);
	const [swapSubmitting, setSwapSubmitting] = useState(false);

	const modalClose = () => { setAssignModal(false), setEmpList(''), setSearch('') };
	const modalShow = () => setAssignModal(true);

	const getShiftSlots = (positionFilled, startTime, endTime) => {
		const parseTime = (time) => {
			const [h, m, s] = time.split(':').map(Number);
			return h * 60 + m + s / 60;
		};

		const formatMinutes = (mins) => {
			let h = Math.floor(mins / 60) % 24;
			let m = Math.floor(mins % 60);
			return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:00`;
		};

		let startMin = parseTime(startTime);
		let endMin = parseTime(endTime);

		const isOvernight = endMin <= startMin;
		if (isOvernight) endMin += 24 * 60;

		const normalizeTime = (t) => {
			let val = parseTime(t);
			if (isOvernight && val < startMin) val += 24 * 60;
			return val;
		};

		const sorted = [...(positionFilled || [])].sort(
			(a, b) => normalizeTime(a.Start_Time) - normalizeTime(b.Start_Time)
		);

		const slots = [];
		let currentStart = startMin;

		sorted.forEach((emp) => {
			let empStart = normalizeTime(emp.Start_Time);
			let empEnd = normalizeTime(emp.End_Time);

			if (empEnd <= empStart) empEnd += 24 * 60;

			if (empStart > currentStart) {
				slots.push({ type: 'open', start: currentStart, end: empStart });
			}

			slots.push({
				type: 'filled',
				...emp,
				start: empStart,
				end: empEnd,
			});

			currentStart = empEnd;
		});

		if (currentStart < endMin) {
			slots.push({ type: 'open', start: currentStart, end: endMin });
		}

		return { slots, formatMinutes };
	};


	const columns = (shiftCode, shift, startTime, endTime) => {
		let col = [
			{
				field: 'Position_Name',
				headerName: 'Name',
				flex: 1,
				maxWidth: 200,
				minWidth: 160,
				renderCell: (params) => {
					return (
						<Box>
							{params.value}
						</Box>
					);
				}
			},
			...(v3Data?.V3_OPENPOSITION_VOULTEER_DEPARTMENT && v3Data?.V3_OPENPOSITION_VOULTEER_DEPARTMENT == 'true') ?
				[
					{
						field: 'title',
						headerName: 'Name',
						flex: 1,
						minWidth: 230,
						maxWidth: 400,
						renderCell: (params) => {
							const { slots, formatMinutes } = getShiftSlots(
								params.row.Position_Filled,
								startTime,
								endTime
							);

							return (
								<>
									{slots.map((slot, index) => (
										<div
											key={index}
											className={
												(params?.row?.Position_Filled.length > 0 && slot.type === 'open') ||
													(slot.type === 'filled' && params?.row?.Position_Filled.length > 1)
													? 'shift-arr'
													: ''
											}
											style={{ width: '100%', padding: '12px 0px' }}
										>
											<Row style={{ alignItems: 'center' }} className="g-0">
												{slot.type === 'filled' ? (
													<>
														<Col xs="auto" className="p-0" style={{ whiteSpace: 'normal', color: 'green', fontSize: '13px', fontWeight: '550' }}>
															{slot.Employee_Rank} {slot.Employee_Name} (
															{varFormatTime(timeFormat(formatMinutes(slot.start)), user?.Time_Format)} -{' '}
															{varFormatTime(timeFormat(formatMinutes(slot.end)), user?.Time_Format)})
															{/* <span style={{
																backgroundColor: 'green', borderRadius: 50, color: '#fff', fontWeight: 'bold',
																fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
																alignItems: 'center', justifyContent: 'center'
															}}>
																F
															</span> */}
														</Col>
																											<Col xs="auto" className="p-0">
														<div className="d-flex align-items-center" style={{ gap: 2, marginLeft: 4 }}>
																{permission.includes('Emp_Auth') && (
																	<Tooltip title="Unassign" arrow>
																		<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setDeleteModal(true); setUnassignPosition(params?.row); setUnassignEmp(slot); }}>
																			<img src="/images/revert.png" width={18} height={18} />
																		</IconButton>
																	</Tooltip>
																)}
																{!permission.includes('Emp_Auth') && user?.Emp_Code == slot?.Employee_ID && allowedVars?.V3_SHIFT_TRADE_ENABLED && allowedVars?.V3_SHIFT_TRADE_ENABLED == 'true' && (
																	<Tooltip title="Swap" arrow>
																		<IconButton size="small" sx={{ p: 0.5 }} onClick={() => openSwapModal(slot, params.row)}>
																			<SwapHorizIcon sx={{ color: "#BF1D2D", fontSize: 20 }} />
																		</IconButton>
																	</Tooltip>
																)}
																{permission.includes('Emp_Auth') && (
																	<Tooltip title="Edit time" arrow>
																		<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setEditEmp(slot); setEditStartTime(dayjs(`2000-01-01T${slot.Start_Time}`).toDate()); setEditEndTime(dayjs(`2000-01-01T${slot.End_Time}`).toDate()); setEditModal(true); }}>
																			<img src="/images/edit.svg" width={18} height={18} />
																		</IconButton>
																	</Tooltip>
																)}
															</div>
													</Col>
													</>
												) : (
													<Col md={10} className="p-0" style={{ textAlign: 'left', color: 'red', fontSize: '13px' }}>
														Open Position (
														{varFormatTime(timeFormat(formatMinutes(slot.start)), user?.Time_Format)} -{' '}
														{varFormatTime(timeFormat(formatMinutes(slot.end)), user?.Time_Format)})
													</Col>
												)}
											</Row>
										</div>
									))}
								</>
							);
						},
					},
				]
				:
				[
					{
						field: 'title',
						headerName: 'Name',
						flex: 1,
						minWidth: 230,
						maxWidth: 400,
						renderCell: (params) => (
							<div className={params?.row?.Position_Filled.length > 1 && "shift-arr"} style={{ width: '100%' , padding: '12px 0px'}}>
								{params.row.Position_Filled.length > 0
									? params.row.Position_Filled.map((emp, index) => (
										<Row style={{ alignItems: 'center'}} className="g-0">
											<Col xs="auto" className="p-0" style={{ whiteSpace: 'normal' }}>
												{emp.Employee_Rank} {emp.Employee_Name + ' '}
												({varFormatTime(timeFormat(emp?.Start_Time), user?.Time_Format)} - {varFormatTime(timeFormat(emp?.End_Time), user?.Time_Format)})
											</Col>
																						<Col xs="auto" className="p-0">
												<div className="d-flex align-items-center" style={{ gap: 2, marginLeft: 4 }}>
													{(permission.includes('Emp_Auth')) &&
														!Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
														<Tooltip title="Unassign" arrow>
															<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setDeleteModal(true); setUnassignEmp(emp); setUnassignPosition(params?.row); }}>
																<img src="/images/revert.png" width={18} height={18} />
															</IconButton>
														</Tooltip>}

													{(permission.includes('Emp_Auth')) &&
														JSON.parse(localStorage.getItem('user'))?.Emp_Code != emp?.Employee_ID &&
														Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
														<Tooltip title="Unassign" arrow>
															<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setDeleteModal(true); setUnassignEmp(emp); setUnassignPosition(params?.row); }}>
																<img src="/images/revert.png" width={18} height={18} />
															</IconButton>
														</Tooltip>}

													{Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
														emp.Allow_Self_Unassign === true &&
														<Tooltip title="Unassign" arrow>
															<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setDeleteModalUser(true); setUnassignEmp(emp); setUnassignPosition(params?.row); }}>
																<img src="/images/revert.png" width={18} height={18} />
															</IconButton>
														</Tooltip>}

													{!permission.includes('Emp_Auth') && allowedVars?.V3_SHIFT_TRADE_ENABLED &&
														allowedVars?.V3_SHIFT_TRADE_ENABLED == 'true' &&
														<Tooltip title="Swap" arrow>
															<IconButton size="small" sx={{ p: 0.5 }} onClick={() => openSwapModal(emp, params.row)}>
																<SwapHorizIcon sx={{ color: "#BF1D2D", fontSize: 20 }} />
															</IconButton>
														</Tooltip>
													}

													{permission.includes('Emp_Auth') &&
														<Tooltip title="Edit time" arrow>
															<IconButton size="small" sx={{ p: 0.5 }} onClick={() => { setEditEmp(emp); setEditStartTime(dayjs(`2000-01-01T${emp.Start_Time}`).toDate()); setEditEndTime(dayjs(`2000-01-01T${emp.End_Time}`).toDate()); setEditModal(true); }}>
																<img src="/images/edit.svg" width={18} height={18} />
															</IconButton>
														</Tooltip>}
												</div>
											</Col>
										</Row>
									))
									:
									<div style={{ textAlign: 'left' }}>Open Position</div>
								}
							</div>
						)
					},
				],
			{
				field: 'action',
				headerName: 'Action',
				flex: 1,
				minWidth: 140,
				renderCell: (params) => {
					const requestShiftAllowed =
						allowedVars &&
						Object.keys(allowedVars).includes('V3_VOLUNTEER_REQUEST_SHIFT');

					const disabled = params?.row?.Has_Requested === true;

					const reqAllowed = params?.row?.Position_Filled.length <= 0;

					if (!permission.includes('Emp_Auth') && reqAllowed && requestShiftAllowed) {
						return (
							<div className="d-flex justify-content-start" style={{ alignItems: 'center' }}>
								<ButtonTheme style={{ backgroundColor: disabled ? '#D0D5DD' : '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px' , fontSize:'13px' }}
									disabled={disabled}
									onClick={() => {
										setPosId(params?.row?.Position_Assignment_Id);
										setPosCode(params?.row?.Position_Code);
										getPositionName(
											shiftCode,
											params?.row?.Position_Assignment_Id
										);
										setRequestShiftUser(true)
									}}>
									<img
										src="/images/assign.png"
										style={{ height: '16px' }}>
									</img>
									Request Shift
								</ButtonTheme>

								{!permission.includes('Emp_Auth') && disabled && requestShiftAllowed &&
									<img
										src="/images/revert.png"
										onClick={() => {
											setPosId(params?.row?.Position_Assignment_Id);
											getPositionName(
												shiftCode,
												params?.row?.Position_Assignment_Id
											);
											setRevertShiftReq(true);
										}}
										width={20}
										height={20}
										style={{ cursor: 'pointer', marginLeft: '8px' }}
									/>}
							</div>
						)
					}

					const availableCount = params.row.Available_Employee_Count;
					const { slots, formatMinutes } = getShiftSlots(
						params.row.Position_Filled,
						startTime,
						endTime
					);

					const hasOpenSlot = slots.some(slot => slot.type === 'open');

					const volunteerAllowed =
						allowedVars &&
						Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN');

					if (permission.includes('Emp_Auth') && hasOpenSlot && volunteerAllowed) {
						return (
							<div style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", gap: '10px' }}>

								<ButtonTheme className='px-2 mt-1' style={{ backgroundColor: availableCount === 0 ? '#BF1D2D' : '#079E46', borderRadius: '10px', gap: '3px', padding: '4px' }}
									onClick={() => {
										setPosId(params?.row?.Position_Assignment_Id);
										setShiftCode(shiftCode);
										setPosCode(params?.row?.Position_Code);
										setModalShiftName(shift);
										const openSlot = slots.find((s) => s.type === 'open');
										setDefaultCustomStart(openSlot ? formatMinutes(openSlot.start) : '');
										setDefaultCustomEnd(openSlot ? formatMinutes(openSlot.end) : '');
										setIsPartialSlot(params.row.Position_Filled.length > 0);
										getEmployeeList(
											shiftCode,
											params?.row?.Position_Code,
											params?.row?.Position_Assignment_Id
										);
										modalShow();
									}}>
									<span
										style={{
											position: "absolute",
											top: "-7px",
											right: "-8px",
											background: 'white',
											color: availableCount === 0 ? "#ea4a5a" : "#22C55E",
											border: availableCount === 0 ? "2px solid #ea4a5a" : "2px solid #22C55E",
											borderRadius: "50%",
											width: "18px",
											height: "18px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											fontSize: "13px",
											fontWeight: 700
										}}
									>
										{availableCount}
									</span>
									<img
										src="/images/assign-1.png"
										style={{ height: '15px' }}>
									</img>
									Assign
								</ButtonTheme>

								{JSON.parse(localStorage.getItem('user'))?.Functional_Department != "FH247" &&
									<ButtonTheme className='px-2 mt-1' style={{ backgroundColor: '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px' }}
										onClick={() => {
											setPosId(params?.row?.Position_Assignment_Id);
											setPosCode(params?.row?.Position_Code);
											getPositionName(
												shiftCode,
												params?.row?.Position_Assignment_Id
											);
											setAssignModalUser(true)
										}}>
										<img
											src="/images/assign.png"
											style={{ height: '16px' }}>
										</img>
										To Me
									</ButtonTheme>
								}
							</div>
						)
					}

					if (permission.includes('Emp_Auth') && hasOpenSlot) {
						return (
							<div style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", gap: '10px' }}>

								<ButtonTheme style={{ backgroundColor: availableCount === 0 ? '#BF1D2D' : '#079E46', borderRadius: '10px', gap: '3px', padding: '4px' }}
									onClick={() => {
										setPosId(params?.row?.Position_Assignment_Id);
										setShiftCode(shiftCode);
										setPosCode(params?.row?.Position_Code);
										setModalShiftName(shift);
										const openSlot = slots.find((s) => s.type === 'open');
										setDefaultCustomStart(openSlot ? formatMinutes(openSlot.start) : '');
										setDefaultCustomEnd(openSlot ? formatMinutes(openSlot.end) : '');
										setIsPartialSlot(params.row.Position_Filled.length > 0);
										getEmployeeList(
											shiftCode,
											params?.row?.Position_Code,
											params?.row?.Position_Assignment_Id
										);
										modalShow();
									}}>
									<span
										style={{
											position: "absolute",
											top: "-7px",
											right: "-8px",
											background: 'white',
											color: availableCount === 0 ? "#ea4a5a" : "#22C55E",
											border: availableCount === 0 ? "2px solid #ea4a5a" : "2px solid #22C55E",
											borderRadius: "50%",
											width: "18px",
											height: "18px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											fontSize: "12px",
											fontWeight: 600
										}}
									>
										{availableCount}
									</span>
									<img
										src="/images/assign-1.png"
										style={{ height: '15px' }}>
									</img>
									Assign
								</ButtonTheme>
							</div>
						);
					}

					if (volunteerAllowed && hasOpenSlot) {
						return (
							<div className="w-100 d-flex justify-content-start">
								<ButtonTheme style={{ backgroundColor: '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px' }}
									onClick={() => {
										setPosId(params?.row?.Position_Assignment_Id);
										setPosCode(params?.row?.Position_Code);
										getPositionName(
											shiftCode,
											params?.row?.Position_Assignment_Id
										);
										setAssignModalUser(true)
									}}>
									<img
										src="/images/assign.png"
										style={{ height: '16px' }}>
									</img>
									To Me
								</ButtonTheme>
							</div>
						);
					}
					return '';
				},
			}
		]
		return col
	}

	const getPositionList = () => {
		setLoading(true)
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"_": Date.now()
		}
		ApiService.get('/volunteer-list-positions', body, 'volunteer-list-positions')
			.then((data) => {
				var temp = []
				shift.map((a) => {
					if (mode2 == '24') {
						data?.data?.result.map((b) => {
							if (b.Positions[a?.Shift] !== undefined) {
								temp.push({
									data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode, startTime: a?.Start_Time, endTime: a?.End_Time
								})
							}
						})
					}
					else if (a?.Options === 'NIGHT' && mode2 == 'night') {
						data?.data?.result.map((b) => {
							if (b.Positions[a?.Shift] !== undefined) {
								temp.push({
									data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode, startTime: a?.Start_Time, endTime: a?.End_Time
								})
							}
						})
					}
					else {
						if (a?.Options === 'DAY' && mode2 == 'day') {
							data?.data?.result.map((b) => {
								if (b.Positions[a?.Shift] !== undefined) {
									temp.push({
										data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode, startTime: a?.Start_Time, endTime: a?.End_Time
									})
								}
							})
						}
					}
				})
				// define the custom order
				const order = {
					'Primary Coverage': 1,
					'Second Crew': 2,
					'Third Crew': 3
				};

				temp.sort((a, b) => {
					return (order[a.posName] || 99) - (order[b.posName] || 99);
				});
				setPosList2(temp)
				setLoading(false)
			})
			.catch(() => {
				console.error('err')
				setLoading(false)
			})
	}

	const getShiftList = () => {
		ApiService.get('/shiftTypes')
			.then((data) => {
				setShift(data?.data?.data)
			})
			.catch((err) => {
				console.error('error')
			})
	}

	const unAssignPosition = () => {
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": unassignEmp?.Shift_Code,
			"Start_Time": unassignEmp?.Start_Time,
			"End_Time": unassignEmp?.End_Time,
			"Emp_Code": unassignEmp?.Employee_ID,
			"Position_Assignment_Id": unassignPosition?.Position_Assignment_Id,
			"Unassign_Note": unAssignReason
		}
		ApiService.post('/volunteer-unassign-position', body)
			.then((data) => {
				getPositionList()
				toast.success(data?.message)
				setDeleteModal(false)
				setUnAssignReason('')
			})
			.catch((err) => {
				toast.error('Error')
				setDeleteModal(false)
			})
	}

	const getEmployeeList = (shift_code, pos_code, pos_id) => {
		setEmpLoading(true);
		let tempShiftCode = shift_code ? shift_code : shiftCode
		let tempPosCode = pos_code ? pos_code : posCode
		let tempPosId = pos_id ? pos_id : posId
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": tempShiftCode,
			"Position_Code": tempPosCode,
			"Position_Assignment_Id": tempPosId,
			"search": search
		}
		ApiService.post('/volunteer-hitlist-employees', body)
			.then((data) => {
				setEmpList(data?.employees)
				setEmpLoading(false);
			})
			.catch(() => {
				console.error('error')
				setEmpLoading(false);
			})
	}

	const assignPosition = (row, type = 'fulltime') => {
		var body = {}
		if (type == 'custom') {
			if (startTime == '' || endTime == '') {
				toast.error('Please fill start time and end time')
				return
			}
			body = {
				"Shift_Date": assignEmp?.Shift_Date,
				"Shift_Code": assignEmp?.Shift_Code,
				"Start_Time": startTime,
				"End_Time": endTime,
				"Emp_Code": assignEmp?.Emp_Code,
				"Position_Assignment_Id": posId,
				"isFullTime": false,
				"Force_Assign": !(row?.Has_Volunteer_Signup),
			}
		}
		else if (type == 'partial') {
			if (!defaultCustomStart || !defaultCustomEnd) {
				toast.error('No open time slot available')
				return
			}
			body = {
				"Shift_Date": row?.Shift_Date,
				"Shift_Code": row?.Shift_Code,
				"Start_Time": defaultCustomStart,
				"End_Time": defaultCustomEnd,
				"Emp_Code": row?.Emp_Code,
				"Position_Assignment_Id": posId,
				"isFullTime": false,
				"Force_Assign": !(row?.Has_Volunteer_Signup),
			}
		}
		else {
			body = {
				"Shift_Date": row?.Shift_Date,
				"Shift_Code": row?.Shift_Code,
				"Start_Time": row?.Start_Time,
				"End_Time": row?.End_Time,
				"Emp_Code": row?.Emp_Code,
				"Position_Assignment_Id": posId,
				"isFullTime": row?.Value == 'FULLTIME' ? true : false,
				"Force_Assign": !(row?.Has_Volunteer_Signup),
			}
		}
		ApiService.post('/volunteer-assign-position', body)
			.then((data) => {
				toast.success(data?.message)
				modalClose()
				setCustomModal(false)
				setStartTime('')
				setEndTime('')
				getPositionList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	const assignUserPosition = (fullTime) => {
		const body = {
			"Shift_Date": posUserDate,
			"Shift_Code": posUserShiftCode,
			"Start_Time": startTime ? startTime : posUserStartTime,
			"End_Time": endTime ? endTime : posUserEndTime,
			"Position_Assignment_Id": posId,
			"isFullTime": fullTime
		}
		ApiService.post('/employee-assign-volunteer-position', body)
			.then((data) => {
				setCustomModalUser(false)
				setAssignModalUser(false)
				toast.success(data?.message)
				setStartTime('')
				setEndTime('')
				setPosUserDate('')
				setPosUserShiftCode('')
				setPosUserStartTime('')
				setPosUserEndTime('')
				getPositionList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	const unAssignUserPosition = () => {
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": unassignEmp?.Shift_Code,
			"Start_Time": unassignEmp?.Start_Time,
			"End_Time": unassignEmp?.End_Time,
			"Position_Assignment_Id": unassignPosition?.Position_Assignment_Id
		}
		ApiService.post('/employee-unassign-volunteer-position', body)
			.then((data) => {
				getPositionList()
				toast.success(data?.message)
				setDeleteModalUser(false)
			})
			.catch((err) => {
				toast.error(err?.data?.message)
				setDeleteModalUser(false)
			})
	}

	const revertReqAssign = () => {
		const body = {
			"Shift_Date": posUserDate,
			"Shift_Code": posUserShiftCode,
			"Position_Assignment_Id": posId
		}
		ApiService.post('/revert-request-assignment', body)
			.then((data) => {
				toast.success(data?.message)
				setPosUserDate('')
				setPosUserShiftCode('')
				setRevertShiftReq(false)
				getPositionList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
				setDeleteModalUser(false)
			})
	}

	const requestShift = () => {
		const body = {
			"Shift_Date": posUserDate,
			"Shift_Code": posUserShiftCode,
			"Position_Assignment_Id": posId,
		}
		ApiService.post('/requestAssignmentShift', body)
			.then((data) => {
				toast.success(data?.message)
				setPosUserDate('')
				setPosUserShiftCode('')
				setRequestShiftUser(false)
				getPositionList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	const updatePositionFillTime = () => {
		if (!editStartTime || !editEndTime) {
			toast.error('Please fill start time and end time');
			return;
		}
		const body = {
			"Position_Assignment_Fill_Id": editEmp?.Position_Assignment_Fill_Id,
			"emp_code": editEmp?.Employee_ID,
			// "shift_code": editEmp?.Shift_Code,
			"Start_Time": moment(editStartTime).format('HH:mm:ss'),
			"End_Time": moment(editEndTime).format('HH:mm:ss'),
		};
		ApiService.post('/updatePositionAssignmentFillTime', body)
			.then((data) => {
				toast.success(data?.message || 'Updated successfully');
				setEditModal(false);
				setEditEmp(null);
				setEditStartTime(null);
				setEditEndTime(null);
				getPositionList();
			})
			.catch((err) => {
				toast.error(err?.data?.message || 'Error updating time');
			});
	};

	const openSwapModal = (emp, position) => {
		setSwapEmp(emp);
		setSwapPosition(position);
		setSwapTab('normal');
		setSelectedSwapEmp(null);
		setCollateralList([]);
		setSwapModal(true);
	};

	const handleSwapTabChange = (tab) => {
		setSwapTab(tab);
		setSelectedSwapEmp(null);
		if (tab === 'collateral') {
			fetchCollaterals();
		}
	};

	const fetchCollaterals = () => {
		setSwapLoading(true);
		const shiftDate = date ? date : moment().format('YYYY-MM-DD');
		const body = {
			"Position_Assignment_Id": swapPosition?.Position_Assignment_Id,
			"Shift_Code": swapEmp?.Shift_Code,
			"Start_Time": swapEmp?.Start_Time,
			"End_Time": swapEmp?.End_Time,
			"Emp_Code": swapEmp?.Employee_ID,
			"Shift_Date": shiftDate,
		};
		ApiService.post('/volunteer-shift-swap-collateral-list', body)
			.then((data) => {
				setCollateralList(data?.data || []);
				setSwapLoading(false);
			})
			.catch(() => {
				setCollateralList([]);
				setSwapLoading(false);
			});
	};

	const submitSwap = () => {
		if (!selectedSwapEmp) {
			toast.error('Please select an employee');
			return;
		}
		const shiftDate = date ? date : moment().format('YYYY-MM-DD');
		let body = {
			"Position_Assignment_Id": swapPosition?.Position_Assignment_Id,
			"Shift_Date": shiftDate,
			"Shift_Code": swapEmp?.Shift_Code,
			"Start_Time": swapEmp?.Start_Time,
			"End_Time": swapEmp?.End_Time,
			"Emp_Code": swapEmp?.Employee_ID,
			"New_Emp_Code": selectedSwapEmp?.Emp_Code ?? selectedSwapEmp?.New_Emp_Code,
		};
		if (swapTab === 'collateral') {
			body = {
				...body,
				"New_Emp_Code": selectedSwapEmp?.New_Emp_Code ?? selectedSwapEmp?.Emp_Code,
				"Collateral_Position_Assignment_Id": selectedSwapEmp?.Collateral_Position_Assignment_Id ?? selectedSwapEmp?.Position_Assignment_Id,
				"Collateral_Shift_Date": selectedSwapEmp?.Collateral_Shift_Date ?? selectedSwapEmp?.Shift_Date ?? shiftDate,
				"Collateral_Shift_Code": selectedSwapEmp?.Collateral_Shift_Code ?? selectedSwapEmp?.Shift_Code,
				"Collateral_Start_Time": selectedSwapEmp?.Collateral_Start_Time ?? selectedSwapEmp?.Start_Time,
				"Collateral_End_Time": selectedSwapEmp?.Collateral_End_Time ?? selectedSwapEmp?.End_Time,
			};
		}
		setSwapSubmitting(true);
		ApiService.post('/volunteer-shift-swap', body)
			.then((data) => {
				toast.success(data?.message || 'Employee swapped successfully');
				setSwapModal(false);
				setSwapSubmitting(false);
				getPositionList();
			})
			.catch((err) => {
				toast.error(err?.data?.message || 'Error swapping employee');
				setSwapSubmitting(false);
			});
	};

	const swapOptionLabel = (o) => {
		if (!o) return '';
		const rank = o?.EA_Rank || o?.Employee_Rank || o?.Emp_Rank ||  '';
		const name = o?.fullName || o?.Employee_Name || o?.Emp_Name || '';
		return `${rank} ${name}`.trim();
	};

	const getPositionName = (shift_code, pos_id) => {
		let tempShiftCode = shift_code ? shift_code : shiftCode
		let tempPosId = pos_id ? pos_id : posId
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": tempShiftCode,
			"Position_Assignment_Id": tempPosId,
		}
		ApiService.post('/employee-volunteer-position-detail', body)
			.then((data) => {
				setPosUserDate(data?.shift_date)
				setPosUserShiftCode(data?.shift_detail?.Shift_Code)
				setPosUserStartTime(data?.shift_detail?.Start_Time)
				setPosUserEndTime(data?.shift_detail?.End_Time)
			})
			.catch(() => {
				console.error('error')
			})
	}

	const selectShift = (type, time) => {
		// let checkTime = moment(time).format('HH:mm:ss')
		// if (shiftCode == 2) {
		// 	if (checkTime < '08:00:00' || checkTime > '18:00:00') {
		// 		toast.error('Please select time between 08:00:00 and 18:00:00')
		// 		setKey(val => val + 1)
		// 		return
		// 	}
		// }
		// else if (shiftCode == 3) {
		// 	if (checkTime < '18:00:00' && checkTime > '08:00:00') {
		// 		toast.error('Please select time between 18:00:00 and 08:00:00')
		// 		setKey2(val => val + 1)
		// 		return
		// 	}
		// }
		if (type == 'start_time') {
			setStartTime(moment(time).format('HH:mm:ss'))
		}
		else {
			setEndTime(moment(time).format('HH:mm:ss'))
		}
	}

	useEffect(() => {
		setIsFirsttime(false)
		// getShiftList()
	}, [])

	useEffect(() => {
		if (shift && shift.length > 0) {
			getPositionList()
		}
	}, [shift, mode2])

	useEffect(() => {
		if (!isFirstTime && (search.length >= 3 || search == '')) {
			setTimeout(() => {
				getEmployeeList();
			}, 500);
		}
	}, [search])

	return (
		loading ? 
		<div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
			<CircularProgress />
		</div>
		:
		<>
			{posList2 &&
				<div style={{
					marginTop: '16px',
					display: 'flex',
					justifyContent: 'left',
					alignItems: 'end',
					paddingLeft: '8px',
					fontSize: '18px',
					fontWeight: 600,
				}}>
					{allowedVars?.V3_VERBIAGE_VOLUNTEER ? "Per-diem Position Assignment" : "Volunteer Position Assignment"}
				</div>
			}

			<Row className="w-100 g-1">
				{posList2 && posList2.map((result, outerIndex) => {
					return (
						<Col md={6}>
							<CollapseComponent
								key={outerIndex}
								rows={result?.data}
								name={
									result?.posName +
									(
										result?.shift === '1' || result?.shift === '2' || result?.shift === '3' || result?.shift === '4' || result?.shift === '5'
											? `(Shift-${result?.shift})`
											: `(${result?.shift})`
									)
								}
								columns={columns(result?.shiftCode, result?.shift, result?.startTime, result?.endTime)}
								checkboxSelection={false}
								open={open}
								onExpandChange={onExpandChange}
								showHeader={false}
							/>
						</Col>
					);
				})}
			</Row>

			<Modal size="lg" show={assignModal} onHide={modalClose}>
				<Modal.Body className='p-4'>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
							Available Personnel For Shift - {modalShiftName}
						</Typography>
						<img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={modalClose} />
					</div>

					<Box id="modal-modal-description" sx={{ mt: 2 }}>
						<TextField
							variant="outlined"
							placeholder="Search by Name"
							className="mt-0 w-100"
							color='secondary'
							onChange={(e) => setSearch(e.target.value)}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton>
											<SearchIcon />
										</IconButton>
									</InputAdornment>
								),
								sx: {
									height: '48px',
									fontSize: '14px'
								},
							}}
						/>

						{empLoading &&
							<div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
								<CircularProgress />
							</div>
						}


						{!empLoading && empList?.length === 0 ? (
							<>
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 'auto', marginTop: '10px' }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No results found
									</span>
								</div>
							</>
						) : (<>
							{!empLoading &&
								<div style={{ maxHeight: '60vh', overflowX: 'auto', scrollbarWidth: 'none' }}>
									<TableContainer component={Paper} sx={{
										boxShadow: 'none !important',
										border: '1px solid #EAECF0',
										mt: 2,
										//   minWidth: allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR ? '60vw' : 'auto'
									}}>

										<Table aria-label="customized table">
											<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
												<TableRow>
													<TableCell sx={{ minWidth: 130 }}>Name</TableCell>
													<TableCell sx={{ minWidth: 90 }} >Availability</TableCell>
													<TableCell sx={{ minWidth: 50 }} >Hours</TableCell>
													{allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR && (
														<TableCell sx={{ minWidth: 40 }} >Weekly Hour</TableCell>
													)}
													<TableCell sx={{ minWidth: 130 }}>Timestamp</TableCell>
													<TableCell sx={{ minWidth: 200 }}>Action</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{empList.length > 0 ? empList.map((row) => (

													<TableRow key={row?.fullName} sx={{
														height: '22px',
														'& .MuiTableCell-root': {
															border: 'none',
															color: row?.Has_Volunteer_Signup === false ? 'red !important' : 'inherit'
														},
														'&:nth-of-type(even)': {
															backgroundColor: 'rgba(204, 204, 204, 0.2)',
														},
													}}>

														<TableCell component="th" scope="row">
															{row?.fullName}
														</TableCell>

														<TableCell component="th" scope="row">
															{/* {moment(row?.Shift_Date).format('dddd')}  */}
															{/* {row?.Value != 'FULLTIME' ? 'on ' + row?.Value.replace(/(^\s*,)|(,\s*$)/g, '') : ''} */}
															{row?.Has_Volunteer_Signup === false ? '-' : (row?.Value == 'FULLTIME' ? 'Fulltime' : varFormatTime(timeFormat(row?.Start_Time), user?.Time_Format) + (' - ') + varFormatTime(timeFormat(row?.End_Time), user?.Time_Format))}
														</TableCell>

														{/* <TableCell component="th" scope="row">
														{row?.Seniority}
													</TableCell> */}

														<TableCell component="th" scope="row">
															{row?.Hours}
														</TableCell>
														{allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR && (
															<TableCell component="th" scope="row">
																{row?.Weekly_Overtime_Hours}
															</TableCell>
														)}
														<TableCell component="th" scope="row">
															{row?.LogTime ? moment(row.LogTime).format("MM/DD/YYYY, HH:mm") : ""}
														</TableCell>
														<TableCell component="th" scope="row" align="right">
															<Row>
																<Col md={6}>
																	<Chip sx={{
																		height: 'auto',
																		color: 'red',
																		'& .MuiChip-label': {
																			display: 'block',
																			whiteSpace: 'normal',
																		},
																	}}
																		style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
																		label='Assign'
																		color="red"
																		onClick={() => {
																			if (row?.Has_Volunteer_Signup === false) {
																				setCurrentRow(row);
																				setActionType("assign");
																				setConfirmModal(true);
																			} else {
																				assignPosition(row, isPartialSlot ? 'partial' : 'fulltime');
																			}
																		}}
																	/>
																</Col>

																<Col md={6}>
																	<Chip sx={{
																		height: 'auto',
																		color: 'red',
																		'& .MuiChip-label': {
																			display: 'block',
																			whiteSpace: 'normal',
																		},
																	}}
																		style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
																		label='Custom'
																		color="red"
																		onClick={() => {
																			if (row?.Has_Volunteer_Signup === false) {
																				setCurrentRow(row);
																				setActionType("custom");
																				setConfirmModal(true);
																			} else {
																				setAssignEmp(row);
																				setStartTime(defaultCustomStart);
																				setEndTime(defaultCustomEnd);
																				setCustomModal(true);
																			}
																		}}


																	/>
																</Col>
															</Row>
														</TableCell>

													</TableRow>
												))
													:
													<TableRow>
														<TableCell colSpan={6} style={{ textAlign: 'center' }}>
															No results found
														</TableCell>
													</TableRow>
												}
											</TableBody>
										</Table>
									</TableContainer>
								</div>
							}
						</>)}

					</Box>
				</Modal.Body>
			</Modal>

			<Modal show={deleteModal} onHide={() => { 
				setDeleteModal(false) 
				setUnAssignReason('')
				}}>
				<Modal.Header closeButton>
				<Modal.Title>Unassign Employee</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				<div style={{ color: '#555555' , marginLeft:'5px' }}>
				Are you sure you want to unassign 
				<span style={{color:'#000000'}}>{" " + unassignEmp?.Employee_Rank + " " + unassignEmp?.Employee_Name} </span>
				from the shift on 
				<span style={{color:'#000000'}}>{" " + moment(date).format('MM/DD/YYYY')} {`(${unassignEmp?.Start_Time} - ${unassignEmp?.End_Time})`}?</span>
				</div>
					{(v3Data.V3_VOLUNTEER_REQUIRE_UNASSIGN_NOTE || v3Data.V3_VOLUNTEER_REQUIRE_UNASSIGN_NOTE == 'true') &&
						<Row className="px-3 mt-2">
							<Col md={12} className="p-0">
								<label className="mt-2">Reason (Optional)</label>
								<TextField
									className='mt-1 w-100'
									multiline
									color='secondary'
									variant="outlined"
									value={unAssignReason}
									placeholder="Enter Reason"
									sx={{
										"& .MuiInputBase-input": {
											minHeight: '150px',
											maxHeight: '150px',
											overflow: 'scroll !important',
										}
									}}
									onChange={(e) => setUnAssignReason(e.target.value)}
								/>
							</Col>
						</Row>
					}
				<Row>
					<Col md='auto'>
					<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModal(false) }}>
						Cancel
					</ButtonTheme>
					</Col>
					<Col md='auto'>
					<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={unAssignPosition}>
						Unassign
					</ButtonTheme>
					</Col>
				</Row>
				</Modal.Body>
			</Modal>

			<Modal show={customModal} onHide={() => setCustomModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Custom Time</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									className="m-0"
									key={key}
									value={startTime ? dayjs(`2000-01-01T${startTime}`).toDate() : null}
									//   onAccept={(newValue) => selectShift('start_time', newValue)}
									onChange={(newValue) => selectShift('start_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>

						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									key={key2}
									className="m-0"
									value={endTime ? dayjs(`2000-01-01T${endTime}`).toDate() : null}
									//   onAccept={(newValue) => selectShift('end_time', newValue)}
									onChange={(newValue) => selectShift('end_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCustomModal(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => assignPosition('', 'custom')}>
								Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<Modal show={confirmModal} onHide={() => setConfirmModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Are you sure?</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div style={{ color: '#555555' }}>
						{/* This user didn't put signup for this position, Are you  want to assign this user to this position? */}
						This user hasn't signed up for this position. Do you still want to assign them to it?
					</div>

					<Row className="mt-4">
						<Col md="auto">
							<ButtonTheme
								variant="filled"
								color="white"
								onClick={() => setConfirmModal(false)}
							>
								Cancel
							</ButtonTheme>
						</Col>

						<Col md="auto">
							<ButtonTheme
								variant="filled"
								color="primary"
								onClick={() => {
									setConfirmModal(false);

									if (actionType === "assign") {
										assignPosition(currentRow, isPartialSlot ? 'partial' : 'fulltime');
									}

									if (actionType === "custom") {
										setAssignEmp(currentRow);
										setStartTime(defaultCustomStart);
										setEndTime(defaultCustomEnd);
										setCustomModal(true);
									}
								}}
							>
								Confirm
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* User Modal */}
			<Modal show={assignModalUser} onHide={() => { setAssignModalUser(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Assign Position</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure you want to assign yourself on this position?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { assignUserPosition(true) }}>
								Full Time
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { setCustomModalUser(true) }}>
								Custom
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* User Custom */}
			<Modal show={customModalUser} onHide={() => setCustomModalUser(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Custom Time</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									className="m-0"
									key={key}
									onChange={(newValue) => selectShift('start_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>

						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									key={key2}
									className="m-0"
									onChange={(newValue) => selectShift('end_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCustomModal(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => assignUserPosition(false)}>
								Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* User Delete */}
			<Modal show={deleteModalUser} onHide={() => { setDeleteModalUser(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Unassign Position</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure you want to unassign yourself from this position?
					</div>

					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModalUser(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={unAssignUserPosition}>
								Un-Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* Request Shift Modal */}
			<Modal show={requestShiftUser} onHide={() => { setRequestShiftUser(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Request Shift</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure you want to Request Shift for this position?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setRequestShiftUser(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' disabled={posId == ''} onClick={() => { requestShift() }}>
								Request
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* Revert Request Shift Modal */}
			<Modal show={revertShiftReq} onHide={() => { setRevertShiftReq(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Revert Shift Request</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure you want to revert the request for this position?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setRevertShiftReq(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { revertReqAssign() }}>
								Revert
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* Edit Fill Time Modal */}
			<Modal show={editModal} onHide={() => { setEditModal(false); setEditEmp(null); setEditStartTime(null); setEditEndTime(null); }}>
				<Modal.Header closeButton>
					<Modal.Title>Edit Fill Time</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ marginBottom: '16px' }}>
						<Typography sx={{ fontSize: '15px', fontWeight: '600' }}>
							{editEmp?.Employee_Rank} {editEmp?.Employee_Name}
						</Typography>
					</div>
					<Row>
						<Col md={6}>
							<label className="mb-1">Start Time</label>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									className="m-0"
									value={editStartTime}
									onChange={(newValue) => setEditStartTime(newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>
						<Col md={6}>
							<label className="mb-1">End Time</label>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									className="m-0"
									value={editEndTime}
									onChange={(newValue) => setEditEndTime(newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setEditModal(false); setEditEmp(null); setEditStartTime(null); setEditEndTime(null); }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={updatePositionFillTime}>
								Save
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* Shift Swap Modal */}
			<Modal size="lg" show={swapModal} onHide={() => setSwapModal(false)}>
				<Modal.Body className="p-4">
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<Typography sx={{ fontSize: '21px', fontWeight: '700' }}>Request Swap Shift</Typography>
						<img src="/images/close-icon.svg" style={{ cursor: "pointer" }} onClick={() => setSwapModal(false)} />
					</div>

					{swapEmp &&
						<Typography sx={{ mt: 1, color: '#555555', fontSize: '14px' }}>
							{swapEmp?.Employee_Rank} {swapEmp?.Employee_Name} ({timeFormat(swapEmp?.Start_Time)} - {timeFormat(swapEmp?.End_Time)})
						</Typography>
					}

					<Tabs
						value={swapTab}
						onChange={(e, val) => handleSwapTabChange(val)}
						sx={{ mt: 2, borderBottom: '1px solid #EAECF0', '& .MuiTab-root': { textTransform: 'none', fontWeight: 600 }, '& .Mui-selected': { color: '#BF1D2D !important' }, '& .MuiTabs-indicator': { backgroundColor: '#BF1D2D' } }}
					>
						<Tab value="normal" label="Normal Swap" />
						<Tab value="collateral" label="Collateral Swap" />
					</Tabs>

					<Box sx={{ mt: 3, minHeight: 90 }}>
						{swapLoading ?
							<div className='my-4' style={{ display: 'flex', justifyContent: 'center' }}>
								<CircularProgress />
							</div>
							:
							<Autocomplete
								options={swapTab === 'normal' ? EmployeeToSwap : collateralList}
								getOptionLabel={(o) => swapOptionLabel(o)}
								value={selectedSwapEmp}
								noOptionsText={
									swapTab === "normal"
										? "No employees available for swap"
										: "No collateral employees available for swap"
								}
								onChange={(e, val) => setSelectedSwapEmp(val)}
								isOptionEqualToValue={(o, v) => (o?.Emp_Code ?? o?.New_Emp_Code) === (v?.Emp_Code ?? v?.New_Emp_Code)}
								renderInput={(params) => (
									<TextField {...params} color="secondary" label="Select Employee" placeholder="Search employee" />
								)}
							/>
						}
					</Box>

					<Row className="mt-4">
						<Col md="auto">
							<ButtonTheme type='button' variant='filled' color='white' onClick={() => setSwapModal(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md="auto">
							<ButtonTheme type='button' variant='filled' color='primary' disabled={!selectedSwapEmp || swapSubmitting} onClick={submitSwap}>
								{swapSubmitting ? 'Swapping...' : 'Swap'}
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

{/* {allowedVars && Object.keys(allowedVars).includes('V3_DYNAMIC_SHIFTS_VOLUNTEER') ?
<Row className="w-100">
{(!isNightShift || mode2 == '24') &&
<>
<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.['2']?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name + " " + "(Shift 2)"}
columns={columns(2)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>

<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.['3']?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name + " " + "(Shift 3)"}
columns={columns(2)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>
</>
}
{(isNightShift || mode2 == '24') &&
<>
<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.['1']?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name + " " + "(Shift 1)"}
columns={columns(3)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>

<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.['4']?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name + " " + "(Shift 4)"}
columns={columns(3)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>
</>
}
</Row>
:
<Row className="w-100">
{(!isNightShift || mode2 == '24') &&
<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.Day?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name}
columns={columns(2)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>
}
{(isNightShift || mode2 == '24') &&
<Col md={mode2 == '24' ? 6 : 9} id="col-width">
{posList?.result && posList.result.map((result, outerIndex) => {
const processedRows = result?.Positions?.Night?.map((row, index) => ({
...row,
id: `${outerIndex}-${index}`,
}));
return (
<CollapseComponent
key={outerIndex}
rows={processedRows}
name={result?.Assignment_Name}
columns={columns(3)}
checkboxSelection={false}
open={open}
onExpandChange={onExpandChange}
showHeader={false}
/>
);
})}
</Col>
}
</Row>
} */}